import Dropdown from "@/components/Dropdown";
import Input from "@/components/Input";
import Button from "@/components/Button";
import Table from "@/components/Table";
import HeaderColumn from "@/components/Table/table-header/HeaderColumn";
import HeaderColumnSort from "@/components/Table/table-header/HeaderColumnSort";
import BodyImageWithInfoColumn from "@/components/Table/table-body/BodyImageWithInfoColumn";
import Badge from "@/components/Badge";
import BodyColumn from "@/components/Table/table-body/BodyColumn";
import Pagination from "@/components/Pagination";
import "./style.scss";
import { useParams } from "react-router-dom";
import { ChangeEvent, useEffect, useState } from "react";
import { OptionItem } from "@/components/Dropdown/model";
import { BASE_URL, DROPDOWN_STATUS_OPTIONS, DROPDOWN_STATUS_PRODUCT_OPTIONS } from "@/utils/constant";
import getProductByUserInteractor from "@/@core/interactor/user/get-products-by-user";
import { stringToDate } from "@/utils/date";
let debounceSearch: any;

const ProductsTab = () => {
  const { id } = useParams();

  const [search, setSearch] = useState<string>('');
  const [status, setStatus] = useState<OptionItem>(DROPDOWN_STATUS_PRODUCT_OPTIONS[0]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [products, setProducts] = useState<any[]>([]);

  const getUsersByProduct = async (page = activePage, search: string = '') => {
    try {
      const response = await getProductByUserInteractor({
        id: String(id),
        limit: 5,
        page,
        search,
        status: status.value,
      });

      const {
        data: { data, pagination },
      } = response;

      setProducts(data);

      if (pagination) {
        setActivePage(pagination.current_page);
        setTotalPage(pagination.last_page);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearch(val);

    clearTimeout(debounceSearch);
    debounceSearch = setTimeout(() => {
      getUsersByProduct(1, val);
    }, 500);
  };

  const onSearchEnter = (e: any) => {
    const keyCode = e.keyCode;
    const val = e.target.value;

    if (keyCode === 13) {
      clearTimeout(debounceSearch);
      getUsersByProduct(1, val);
    }
  };

  const onChangePagination = (e: any) => {
    setActivePage(e);
  };

  const onChageStatus = (e: any) => {
    setStatus(e);
  };

  const resetFilter = () => {
    setSearch('');
    setStatus(DROPDOWN_STATUS_OPTIONS[0]);
    setActivePage(1)
  };

  useEffect(() => {
    getUsersByProduct(activePage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, status.value]);

  return (
    <div className="products-tab-wrapper">
      <div className="table-control">
        <div>
          <label>Search for product</label>
          <Input
            style={{ width: '360px' }}
            value={search}
            withIcon
            type="search"
            placeholder="Search"
            onChange={onChangeSearch}
            onKeyDown={onSearchEnter}
          />
        </div>
        <div>
          <label>Status</label>
          <Dropdown
            value={status}
            options={DROPDOWN_STATUS_PRODUCT_OPTIONS}
            onChange={onChageStatus}
            optionType="text-option"
            width="192px"
          />
        </div>
        <div className="btn-wrapper">
          <Button
            onClick={resetFilter}
            label="Reset Filter"
            type="secondary"
            size="md"
            disabled={!search && status.value === 0}
          />
        </div>
      </div>

      <div className="table-section">
        <Table>
          <thead>
            <tr>
              <HeaderColumn label="Product" alignLabel="text-left" />
              <HeaderColumnSort
                label="Status"
                sortType={'asc'}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
              <HeaderColumn label="Serial Number" alignLabel="text-left" />
              <HeaderColumn label="Claim Location" alignLabel="text-left" />
              <HeaderColumnSort
                label="Claimed at"
                sortType={'asc'}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
              <HeaderColumnSort
                label="Unlink at"
                sortType={'asc'}
                onChange={(e) => {}}
                alignLabel="text-center"
              />
            </tr>
          </thead>
          <tbody>
            {products.map((product, idx) => (
              <tr>
                <BodyImageWithInfoColumn
                  width="200px"
                  imgSrc={BASE_URL + '/file' + product.product_photo}
                  roundedImg="20px"
                  textName={product.product_name}
                  textDesc=""
                />
                <td width="100px">
                  <div className="item-center">
                    <Badge
                      label={product.status}
                      backgroundColor="#ECFDF3"
                      labelColor={
                        product.status === 'owned' ? '#067647' : '#344054'
                      }
                    />
                  </div>
                </td>
                <BodyColumn
                  width="200px"
                  label={product?.serial_number}
                  alignLabel="text-left"
                  color="black"
                />
                <BodyColumn
                  width="200px"
                  label={product?.city}
                  alignLabel="text-center"
                  color="black"
                />
                <BodyColumn
                  width="200px"
                  label={stringToDate(product.claimed_at, "dd month yyyy")}
                  alignLabel="text-center"
                  color="black"
                />
                <BodyColumn
                  width="200px"
                  label={stringToDate(product.unclaimed_at, "dd month yyyy")}
                  alignLabel="text-center"
                  color="black"
                />
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination 
          activePage={activePage} 
          totalPage={totalPage} 
          onChange={onChangePagination}
        />
      </div>
    </div>
  );
};

export default ProductsTab;
